import React from "react";
import { ArrowDownIcon, CheckIcon, ClipboardCheckIcon, FolderTreeIcon, MapIcon, NetworkIcon, TableIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { extras, volumes } from "../../data/landing";
const extraIcons = [NetworkIcon, ClipboardCheckIcon, TableIcon, FolderTreeIcon, MapIcon];
export function Volumes() {
  return <section className="px-4 py-16 sm:py-20" data-id="element-295" data-mp="2o0v5v4udgd1s">
      <div className="mx-auto max-w-5xl" data-id="element-296" data-mp="2o2oid0ro1rhp">
        <SectionHeading label="What you'll find inside" title="6 premium volumes. One decision system." data-id="element-297" data-mp="2j9d9yv77h2no" />

        <div className="mt-10 space-y-5" data-id="element-298" data-mp="2ea0nibk8xxlm">
          {volumes.map(v => <article key={v.numeral} className="overflow-hidden rounded-3xl border border-brand-100 bg-white" data-id="element-299" data-mp="29bz4fqmtlya5">
              <div className="flex items-center gap-4 bg-brand-700 px-5 py-4 text-white sm:px-7" data-id="element-300" data-mp="25alup5glxaxy">
                <span className="font-serif text-4xl font-black leading-none text-brand-200 sm:text-5xl" data-id="element-301" data-mp="20ahg5kz9eqad">{v.numeral}</span>
                <div className="min-w-0" data-id="element-302" data-mp="334uhpvtz4fu8">
                  <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-brand-200" data-id="element-303" data-mp="333t4bkphjh9c">Volume {v.numeral}</p>
                  <h3 className="font-serif text-xl font-bold leading-tight sm:text-2xl" data-id="element-304" data-mp="2u57se8eir0hj">{v.title}</h3>
                </div>
              </div>
              <div className="p-5 sm:p-7" data-id="element-305" data-mp="2y72rd68z91s5">
                <p className="text-lg font-bold text-brand-700" data-id="element-306" data-mp="3lw43p4kxkx2p">{v.subtitle}</p>
                <p className="mt-2 leading-relaxed text-muted" data-id="element-307" data-mp="3lu12doebvhio">{v.intro}</p>

                {v.flow && <ol className="mt-4 flex flex-col items-stretch gap-1 sm:flex-row sm:flex-wrap sm:items-center sm:gap-2" data-id="element-308" data-mp="3qsuilol01mmj">
                    {v.flow.map((f, i) => <li key={f} className="flex flex-col items-center gap-1 sm:flex-row sm:gap-2" data-id="element-309" data-mp="3hsz3j8obp7h8" data-mpi={i}>
                        <span className="w-full rounded-lg bg-brand-50 px-3 py-2 text-center text-sm font-extrabold uppercase text-brand-800 sm:w-auto" data-id="element-310" data-mp="21ez5y4cy9tx5">
                          {f}
                        </span>
                        {i < v.flow!.length - 1 && <ArrowDownIcon className="h-4 w-4 text-brand-300 sm:-rotate-90" aria-hidden="true" data-id="element-311" data-mp="713fpz7j4deu" />}
                      </li>)}
                  </ol>}

                {v.steps && <ol className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-4" data-id="element-312" data-mp="3ubbgsj12p6co">
                    {v.steps.map((s, i) => <li key={s} className="flex items-center gap-2 rounded-lg bg-brand-50 px-3 py-2.5" data-id="element-313" data-mp="3kef6q8vj0c60" data-mpi={i}>
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-700 text-xs font-bold text-white" data-id="element-314" data-mp="3ff3oswjfb0mu">
                          {i + 1}
                        </span>
                        <span className="text-sm font-bold text-brand-800" data-id="element-315" data-mp="1dnh6djdlke1z">{s}</span>
                      </li>)}
                  </ol>}

                {v.items && <ul className="mt-4 grid grid-cols-1 gap-x-4 gap-y-2 min-[400px]:grid-cols-2 sm:grid-cols-3" data-id="element-316" data-mp="2rjqudg8ur2uz">
                    {v.items.map(it => <li key={it} className="flex items-start gap-2 text-[15px] text-ink" data-id="element-317" data-mp="31alhsnxu48i0">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta-dark" aria-hidden="true" data-id="element-318" data-mp="35bx9cz09r3su" />
                        {it}
                      </li>)}
                  </ul>}

                <p className="mt-5 border-t border-brand-100 pt-4 font-semibold leading-relaxed text-ink" data-id="element-319" data-mp="2dk940wfwrhji">{v.outro}</p>
              </div>
            </article>)}
        </div>

        <div className="mt-16" data-id="element-320" data-mp="2ml79lj5zvx47">
          <h3 className="text-center font-serif text-2xl font-extrabold text-ink sm:text-3xl" data-id="element-321" data-mp="2mmidrk3cr6vu">
            And you'll also get immediate access to:
          </h3>
          <ul className="mx-auto mt-8 max-w-3xl divide-y divide-brand-100 rounded-3xl border border-brand-100 bg-white" data-id="element-322" data-mp="1uyahis65aub">
            {extras.map((e, i) => {
            const Icon = extraIcons[i];
            return <li key={e.title} className="flex gap-4 p-5" data-id="element-323" data-mp="3rldu6o0d7l93" data-mpi={i}>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-50 text-brand-700" data-id="element-324" data-mp="9er4x1lmge1m">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-325" data-mp="5cw2ftryfum9" />
                  </span>
                  <div data-id="element-326" data-mp="jcdj1lv3k1kj">
                    <p className="font-bold text-ink" data-id="element-327" data-mp="jbm0bbmllybo">{e.title}</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-328" data-mp="eec339sywida">{e.text}</p>
                  </div>
                </li>;
          })}
          </ul>
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center font-serif text-2xl font-bold leading-snug text-ink sm:text-3xl" data-id="element-329" data-mp="o3nc6wfutn16">
          Any ECU that arrives at your workshop… <em className="italic text-brand-600" data-id="element-330" data-mp="123oaq58ncidh">you'll have a structured way to figure out what to check next.</em>
        </p>

        <CTAButton className="mt-8" label="Get access to the complete system" data-id="element-331" data-mp="1gq3sf6s0bup9" />
      </div>
    </section>;
}